// Тултип ошибок для полей лендинга.
//
// Порт поведения из ЛК мерчанта (frontend/src/merchant/components/inputs/InputTooltip.vue):
// при ошибке у поля краснеют рамка, введённый текст и плейсхолдер, а сообщение уезжает
// в тултип — справа от поля, если справа есть место, иначе вверх от правого края поля
// (если сверху не влезает — вниз).
//
// ГЛАВНОЕ: тултип прибит к полю так же, как в кабинете, — узел лежит В ОБЁРТКЕ поля
// (position: absolute внутри .input-tooltip-anchor), а не в <body> с position: fixed.
// Поэтому на прокрутке его никто не двигает: он едет вместе со страницей средствами
// браузера, слушателя scroll здесь нет вовсе. Прежняя схема (fixed + пересчёт координат
// на каждом кадре прокрутки) и давала «скольжение»: тултип догонял поле с задержкой в
// кадр и переезжал относительно него от клэмпа во вьюпорт. Обёртке нужен только
// position: relative — его даёт класс .input-tooltip-anchor, который вешает этот скрипт.
//
// Отличие от кабинета: в обёртке лендинга рядом с полем лежит ещё и <label>, поэтому
// координаты внутри обёртки считает JS (от прямоугольника самого поля), а не CSS
// (bottom: 100% отсчитался бы от подписи). Пересчёт нужен только когда меняется
// геометрия — ресайз, открытие модалки, смена текста, — но не на прокрутке.
//
// Текст берётся из соседнего .invalid-feedback — того же блока, куда пишет сообщения
// сервера form-hendler.js. Сам блок скрывается через класс .input-tooltip-ready на <html>
// (без JS сообщения остаются на месте, как было).
//
// Ещё два правила, каждое — следствие поломки:
//  1. Пока поверх страницы открыт слой (шторка бургера, модалка), тултипы полей ЗА ним
//     скрыты МГНОВЕННО: слушаем начало открытия (show.bs.*) и клик по самому
//     переключателю, а не окончание анимации (shown.bs.*) — от него тултип оставался
//     виден ещё долю секунды поверх выезжающего меню. Скрываем через display: none:
//     затухание по opacity здесь тоже читалось бы как «пропадает не сразу».
//  2. Тултипы не накладываются друг на друга: позиции считаются общим проходом
//     (см. place) и разводятся — при нескольких ошибках в форме сообщения ложились
//     одно на другое.
//  3. Свои правки DOM делаем с ОТКЛЮЧЁННЫМИ наблюдателями формы (withoutObservers) и
//     только когда значение реально меняется (setClass/setStyle). Узел тултипа лежит
//     внутри формы, за которой следит MutationObserver, а DOMTokenList переписывает
//     атрибут class при каждом вызове add/remove/toggle — даже если набор классов тот
//     же. Без этого показ тултипа будил наблюдатель, тот звал пересчёт, пересчёт снова
//     писал класс — и страница вставала насмерть.

// Отступ от края вьюпорта/режущей границы, за который тултип не заезжает.
const VIEWPORT_MARGIN = 12;
// Зазор между полем и тултипом.
const GAP = 10;
// Зазор между двумя тултипами при разведении наложений.
const STACK_GAP = 8;
// Хвостик — квадрат 12×12, повёрнутый на 135deg (как в макете кабинета).
const ARROW_SIZE = 12;
// Отступ хвостика от края тултипа.
const ARROW_INSET = 16;
// Класс на обёртке поля: даёт системе координат тултипа position: relative.
const ANCHOR_CLASS = 'input-tooltip-anchor';
// Границы, за которые тултип не выходит: карточка модалки и шторка offcanvas.
// Иначе боковой тултип уезжал бы с тёмной карточки на фон страницы.
const BOUNDARY_SELECTOR = '.modal-content, .offcanvas, [data-tooltip-boundary]';
// Открытый слой поверх страницы (на случай, если он открылся до инициализации).
const OVERLAY_SELECTOR = '.offcanvas.show, .modal.show';
// Переключатели слоёв: по клику прячем тултипы, не дожидаясь событий bootstrap.
const OVERLAY_TOGGLE_SELECTOR = '[data-bs-toggle="offcanvas"], [data-bs-toggle="modal"]';
// Предел шагов разведения наложений — страховка от зацикливания на нерешаемой раскладке.
const STACK_MAX_STEPS = 20;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

// Класс и стиль пишем ТОЛЬКО когда значение меняется. DOMTokenList переписывает
// атрибут class при каждом вызове add/remove/toggle — даже если набор классов тот же,
// — а любая запись атрибута будит MutationObserver формы (тултип лежит внутри неё).
function setClass(el, cls, on) {
  if (el.classList.contains(cls) === on) return;

  el.classList.toggle(cls, on);
}

function setStyle(el, prop, value) {
  if (el.style[prop] === value) return;

  el.style[prop] = value;
}

// Правая граница, до которой тултип может дотянуться: ближайшая карточка модалки
// либо первый предок, который режет содержимое по горизонтали.
function findLimitRight(el) {
  let node = el.parentElement;

  while (node && node !== document.body && node !== document.documentElement) {
    if (node.matches(BOUNDARY_SELECTOR)) {
      return node.getBoundingClientRect().right;
    }

    if (window.getComputedStyle(node).overflowX !== 'visible') {
      return node.getBoundingClientRect().right;
    }

    node = node.parentElement;
  }

  return window.innerWidth;
}

// Верхняя граница, выше которой тултип обрежется: ближайший предок, режущий
// содержимое по вертикали (например .modal со своей прокруткой). Если такого нет,
// граница — верх документа: страницу можно прокрутить, поэтому верх ВЬЮПОРТА
// раскладку не ограничивает (в отличие от прежней fixed-схемы).
function findLimitTop(el) {
  let node = el.parentElement;

  while (node && node !== document.body && node !== document.documentElement) {
    if (node.matches(BOUNDARY_SELECTOR)) {
      return node.getBoundingClientRect().top;
    }

    if (window.getComputedStyle(node).overflowY !== 'visible') {
      return node.getBoundingClientRect().top;
    }

    node = node.parentElement;
  }

  return -window.scrollY;
}

function boxesOverlap(a, b) {
  return (
    a.left < b.left + b.width &&
    b.left < a.left + a.width &&
    a.top < b.top + b.height + STACK_GAP &&
    b.top < a.top + a.height + STACK_GAP
  );
}

// Что наблюдать в форме и что считать «своим» узлом (см. observeForm).
const OBSERVER_CONFIG = { attributes: true, attributeFilter: ['class'], subtree: true };

// Узлы тултипов: их правки класса наблюдатель формы игнорирует.
const ownNodes = new WeakSet();

function isOwnNode(node) {
  let current = node;

  while (current) {
    if (ownNodes.has(current)) return true;

    current = current.parentElement;
  }

  return false;
}

// Слои, которые сейчас открываются или открыты. Класс .show bootstrap ставит уже
// ПОСЛЕ события show.bs.*, поэтому одного селектора мало — держим свой список.
const openOverlays = new Set();

function isCoveredByOverlay(el) {
  let covered = false;

  openOverlays.forEach((overlay) => {
    if (!overlay.contains(el)) covered = true;
  });

  if (covered) return true;

  const shown = document.querySelectorAll(OVERLAY_SELECTOR);

  for (let i = 0; i < shown.length; i += 1) {
    if (!shown[i].contains(el)) return true;
  }

  return false;
}

class FieldTooltip {
  constructor(el) {
    this.el = el;
    // Обёртка поля — она же система координат тултипа (как .si__wrap в кабинете).
    this.anchor = el.parentElement;
    this.tip = null;
    this.content = null;
    this.arrow = null;
    this.visible = false;
    this.text = '';
    // 'right' | 'top' | 'bottom' — выбирается при показе, на прокрутке не меняется.
    this.placement = null;
  }

  // Блок с сообщением лежит рядом с полем (внутри той же обёртки).
  // Ошибку капчи не трогаем — у неё нет своего инпута, она выводится под виджетом.
  findFeedback() {
    if (!this.anchor) return null;

    return (
      Array.from(this.anchor.children).find(
        (node) =>
          node.classList &&
          node.classList.contains('invalid-feedback') &&
          !node.hasAttribute('data-captcha-error'),
      ) || null
    );
  }

  // Поле в ошибке, если так сказал сервер (.is-invalid) либо форма уже
  // валидировалась и нативная валидность не прошла.
  isInvalid() {
    if (this.el.classList.contains('is-invalid')) return true;

    const form = this.el.form;
    if (!form || !form.classList.contains('was-validated')) return false;

    return Boolean(this.el.validity) && !this.el.validity.valid;
  }

  findMessage() {
    const feedback = this.findFeedback();
    const fromFeedback = feedback ? feedback.textContent.trim() : '';

    // Фолбэк на случай поля без своего .invalid-feedback: туда пишет сообщение
    // сервера form-hendler.js.
    return fromFeedback || (this.el.dataset.errorMessage || '').trim();
  }

  ensureTip() {
    if (this.tip || !this.anchor) return;

    const tip = document.createElement('div');
    tip.className = 'input-tooltip';

    const content = document.createElement('div');
    content.className = 'input-tooltip__content';

    const text = document.createElement('span');
    text.className = 'input-tooltip__text';
    content.appendChild(text);

    const arrow = document.createElement('span');
    arrow.className = 'input-tooltip__arrow';

    tip.appendChild(content);
    tip.appendChild(arrow);

    // Абсолютное позиционирование считается от обёртки поля — ей нужен
    // position: relative. Сам тултип вне потока, на разметку обёртки не влияет.
    setClass(this.anchor, ANCHOR_CLASS, true);
    ownNodes.add(tip);
    this.anchor.appendChild(tip);

    this.tip = tip;
    this.content = text;
    this.arrow = arrow;
  }

  sync() {
    const message = this.isInvalid() ? this.findMessage() : '';

    if (message) {
      this.show(message);
    } else {
      this.hide();
    }
  }

  show(message) {
    this.ensureTip();

    if (!this.tip) return;

    if (message !== this.text) {
      this.text = message;
      this.content.textContent = message;
      // Текст сменился — размеры другие, раскладку выбираем заново.
      this.placement = null;
    }

    if (!this.visible) {
      this.placement = null;
    }

    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.placement = null;

    if (this.tip) {
      setClass(this.tip, 'is-visible', false);
    }
  }

  // Раскладку пересматриваем только на ресайзе: на прокрутке она обязана остаться
  // прежней, иначе тултип перескакивает с «вверх» на «вниз» посреди движения.
  resetPlacement() {
    this.placement = null;
  }

  choosePlacement(rect, width, height) {
    const limitRight = Math.min(window.innerWidth, findLimitRight(this.el)) - VIEWPORT_MARGIN;

    // Справа хватает места — встаём сбоку (десктоп). На мобиле места не бывает.
    if (rect.right + GAP + width <= limitRight) {
      return 'right';
    }

    // Иначе — вверх от правого края поля, а если сверху обрежется, то вниз.
    return rect.top - GAP - height < findLimitTop(this.el) + VIEWPORT_MARGIN ? 'bottom' : 'top';
  }

  // Желаемая позиция тултипа в координатах вьюпорта (в них разводятся наложения).
  // null — показывать нечего: поле скрыто или закрыто открытым слоем.
  measure() {
    if (!this.tip || !this.visible) return null;

    const rect = this.el.getBoundingClientRect();

    if ((!rect.width && !rect.height) || isCoveredByOverlay(this.el)) {
      return null;
    }

    // Снимаем display: none, оставленный предыдущим conceal(): у скрытого узла
    // offsetWidth нулевой, и раскладка посчиталась бы по нулевым размерам.
    setStyle(this.tip, 'display', '');

    const width = this.tip.offsetWidth;
    const height = this.tip.offsetHeight;

    if (!this.placement) {
      this.placement = this.choosePlacement(rect, width, height);
    }

    const box = {
      field: this,
      placement: this.placement,
      width: width,
      height: height,
      fieldCenterY: rect.top + rect.height / 2,
      fieldRight: rect.right,
    };

    if (this.placement === 'right') {
      box.left = rect.right + GAP;
      box.top = rect.top + rect.height / 2 - height / 2;

      return box;
    }

    box.left = clamp(
      rect.right - width,
      VIEWPORT_MARGIN,
      Math.max(VIEWPORT_MARGIN, window.innerWidth - VIEWPORT_MARGIN - width),
    );
    box.top = this.placement === 'bottom' ? rect.bottom + GAP : rect.top - GAP - height;

    return box;
  }

  // Переводим позицию из координат вьюпорта в координаты обёртки. Дальше тултип
  // живёт в потоке страницы: прокрутка (страницы, модалки, шторки) двигает его
  // вместе с полем, пересчитывать ничего не нужно.
  apply(box) {
    const anchorRect = this.anchor.getBoundingClientRect();
    const left = box.left - anchorRect.left - this.anchor.clientLeft + this.anchor.scrollLeft;
    const top = box.top - anchorRect.top - this.anchor.clientTop + this.anchor.scrollTop;

    setStyle(this.tip, 'display', '');
    setClass(this.tip, 'input-tooltip--right', box.placement === 'right');
    setClass(this.tip, 'input-tooltip--bottom', box.placement === 'bottom');

    setStyle(this.tip, 'left', `${left}px`);
    setStyle(this.tip, 'top', `${top}px`);

    if (box.placement === 'right') {
      // Сбоку хвостик смотрит на середину поля: тултип мог сместиться при
      // разведении наложений, а поле осталось на месте.
      setStyle(this.arrow, 'left', '');
      setStyle(this.arrow, 'top', `${clamp(
        box.fieldCenterY - box.top,
        ARROW_INSET,
        Math.max(ARROW_INSET, box.height - ARROW_INSET),
      )}px`);
    } else {
      // Хвостик смотрит на правый край поля, но не выезжает за сам тултип.
      setStyle(this.arrow, 'top', '');
      setStyle(this.arrow, 'left', `${clamp(
        box.fieldRight - ARROW_INSET - ARROW_SIZE / 2,
        box.left + ARROW_INSET,
        box.left + box.width - ARROW_INSET,
      ) - box.left - ARROW_SIZE / 2}px`);
    }

    setClass(this.tip, 'is-visible', true);
  }

  // Мгновенное скрытие (поле спрятано или закрыто слоем поверх страницы):
  // display: none, без затухания — иначе тултип «пропадает не сразу».
  conceal() {
    if (!this.tip) return;

    setClass(this.tip, 'is-visible', false);
    setStyle(this.tip, 'display', 'none');
  }
}

const fields = [];
const observedForms = new Map();

let listenersBound = false;
let pauseDepth = 0;

// Пока правим DOM сами — наблюдатели формы отключены. Иначе получается цикл:
// показ тултипа меняет класс узла ВНУТРИ формы → наблюдатель зовёт пересчёт →
// пересчёт снова пишет класс → и так до зависания страницы. Раньше узел лежал в
// <body>, вне наблюдаемого поддерева, и проблемы не было.
function withoutObservers(fn) {
  pauseDepth += 1;

  if (pauseDepth === 1) {
    observedForms.forEach((observer) => observer.disconnect());
  }

  try {
    return fn();
  } finally {
    pauseDepth -= 1;

    if (pauseDepth === 0) {
      observedForms.forEach((observer, form) => observer.observe(form, OBSERVER_CONFIG));
    }
  }
}

function syncAll() {
  withoutObservers(() => {
    fields.forEach((field) => field.sync());
    place();
  });
}

// Ресайз меняет и доступное место справа, и высоту тултипа (перенос текста) —
// только здесь раскладка выбирается заново.
function relayout() {
  withoutObservers(() => {
    fields.forEach((field) => field.resetPlacement());
    place();
  });
}

function layout() {
  withoutObservers(place);
}

// Общий проход по всем видимым тултипам: считаем желаемые позиции и разводим
// наложения. Тултип, поставленный «вверх», отодвигается ВВЕРХ, остальные — вниз:
// так сообщение не наезжает на собственное поле.
function place() {
  const boxes = [];

  fields.forEach((field) => {
    // Скрытый тултип не трогаем: display: none оборвал бы плавное затухание,
    // которое делает CSS по снятию .is-visible.
    if (!field.visible) return;

    const box = field.measure();

    if (!box) {
      field.conceal();
      return;
    }

    boxes.push(box);
  });

  const down = boxes.filter((box) => box.placement !== 'top').sort((a, b) => a.top - b.top);
  const up = boxes.filter((box) => box.placement === 'top').sort((a, b) => b.top - a.top);

  const placed = [];

  down.forEach((box) => {
    stack(box, placed, 1);
    placed.push(box);
  });

  up.forEach((box) => {
    stack(box, placed, -1);
    placed.push(box);
  });

  boxes.forEach((box) => box.field.apply(box));
}

function stack(box, placed, direction) {
  for (let step = 0; step < STACK_MAX_STEPS; step += 1) {
    const hit = placed.find((other) => boxesOverlap(box, other));

    if (!hit) return;

    box.top = direction > 0
      ? hit.top + hit.height + STACK_GAP
      : hit.top - box.height - STACK_GAP;
  }
}

// Прячем всё, что оказалось за открывающимся слоем. Вызывается синхронно, до
// первого кадра со шторкой — тултип не должен мигнуть поверх неё.
function concealBehind(overlay) {
  withoutObservers(() => {
    fields.forEach((field) => {
      if (!field.visible || !field.tip) return;
      if (overlay && overlay.contains(field.el)) return;

      field.conceal();
    });
  });
}

function findField(target) {
  return fields.find((field) => field.el === target) || null;
}

function observeForm(form) {
  if (!form || observedForms.has(form)) return;

  // Классы ставит и снимает form-hendler.js (was-validated, is-invalid, d-none у
  // блока 2FA) — реагируем на любые такие правки внутри формы. Правки самих
  // тултипов отбрасываем: они наши, и реакция на них — тот же цикл.
  const observer = new MutationObserver((records) => {
    if (records.every((record) => isOwnNode(record.target))) return;

    syncAll();
  });

  observedForms.set(form, observer);
  observer.observe(form, OBSERVER_CONFIG);
}

export function initInputTooltips(root = document) {
  const controls = Array.from(root.querySelectorAll('.form-control')).filter(
    (el) => el.type !== 'hidden',
  );

  if (!controls.length) return;

  controls.forEach((el) => {
    if (findField(el) || !el.parentElement) return;

    fields.push(new FieldTooltip(el));
    observeForm(el.form);
  });

  // Сообщения переезжают в тултип только когда он реально работает.
  document.documentElement.classList.add('input-tooltip-ready');

  // Общие слушатели ставим один раз, даже если инициализация вызвана повторно
  // (например, для доехавшего аяксом блока с полями).
  if (listenersBound) {
    syncAll();
    return;
  }

  listenersBound = true;

  // Правка поля гасит его ошибку — договорённость из кабинета.
  const onEdit = (e) => {
    const field = findField(e.target);
    if (!field) return;

    withoutObservers(() => {
      setClass(field.el, 'is-invalid', false);
      delete field.el.dataset.errorMessage;
      field.sync();
      place();
    });
  };

  document.addEventListener('input', onEdit, true);
  document.addEventListener('change', onEdit, true);

  // Обработчики форм ставят was-validated в своём submit — на document событие
  // приходит уже после них.
  document.addEventListener('submit', syncAll);

  // Прокрутку НЕ слушаем: тултип лежит в обёртке поля и едет вместе со страницей.
  window.addEventListener('resize', relayout);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', relayout);
  }

  // Слой поверх страницы: прячем тултипы за ним в том же кадре, в котором он
  // начал открываться, и возвращаем, когда он полностью закрылся.
  ['show.bs.offcanvas', 'show.bs.modal'].forEach((event) =>
    document.addEventListener(event, (e) => {
      openOverlays.add(e.target);
      concealBehind(e.target);
    }),
  );

  ['hidden.bs.offcanvas', 'hidden.bs.modal'].forEach((event) =>
    document.addEventListener(event, (e) => {
      openOverlays.delete(e.target);
      layout();
    }),
  );

  // Открывшийся слой мог изменить геометрию своих же полей (модалка с формой).
  ['shown.bs.offcanvas', 'shown.bs.modal'].forEach((event) =>
    document.addEventListener(event, relayout),
  );

  // Страховка на случай, если события bootstrap не долетят (ленивая инициализация
  // виджета): по клику на переключатель прячем тултипы вне открываемого слоя.
  document.addEventListener(
    'click',
    (e) => {
      const toggle = e.target instanceof Element ? e.target.closest(OVERLAY_TOGGLE_SELECTOR) : null;
      if (!toggle) return;

      const selector = toggle.getAttribute('data-bs-target') || toggle.getAttribute('href');
      const overlay = selector && selector.charAt(0) === '#' ? document.querySelector(selector) : null;

      // Цель не разобрали — ничего не прячем: этим займутся события bootstrap.
      // Иначе неизвестная цель погасила бы вообще все тултипы, а вернуть их было
      // бы нечем (hidden.bs.* по неоткрывшемуся слою не придёт).
      if (!overlay) return;

      concealBehind(overlay);
    },
    true,
  );

  // Страница могла отрисоваться с ошибкой от сервера (например, соц-вход с 2FA).
  syncAll();
}
